import {
  FILE_CHUNK_BYTES,
  TRANSFER_MESSAGE_TYPES,
} from "../localTransfer.constants";

const HEADER_BYTES = 4;
const PERCENTAGE_MULTIPLIER = 100;

const encodeJson = (value) => new TextEncoder().encode(JSON.stringify(value));
const decodeJson = (bytes) => JSON.parse(new TextDecoder().decode(bytes));

export const buildNoteMetadataMessage = ({ title, content, file }) => ({
  type: TRANSFER_MESSAGE_TYPES.NOTE_METADATA,
  title,
  content,
  file: file
    ? {
        name: file.name,
        type: file.type,
        size: file.size,
        lastModified: file.lastModified,
      }
    : null,
});

export const buildTextMessage = (message) => JSON.stringify(message);

export const parseTextMessage = (messageText) => JSON.parse(messageText);

export const getFileChunkCount = (file) => {
  if (!file) return 0;

  return Math.ceil(file.size / FILE_CHUNK_BYTES);
};

export const calculateTransferProgress = ({ receivedBytes, totalBytes }) => {
  if (!totalBytes) return 100;

  return Math.round((receivedBytes / totalBytes) * PERCENTAGE_MULTIPLIER);
};

export const buildFileChunkMessage = async ({ file, chunkIndex, totalChunks }) => {
  const startByte = chunkIndex * FILE_CHUNK_BYTES;
  const chunk = file.slice(startByte, startByte + FILE_CHUNK_BYTES);
  const chunkBytes = new Uint8Array(await chunk.arrayBuffer());
  const headerBytes = encodeJson({
    type: TRANSFER_MESSAGE_TYPES.FILE_CHUNK,
    chunkIndex,
    totalChunks,
  });
  const message = new Uint8Array(HEADER_BYTES + headerBytes.length + chunkBytes.length);

  new DataView(message.buffer).setUint32(0, headerBytes.length);
  message.set(headerBytes, HEADER_BYTES);
  message.set(chunkBytes, HEADER_BYTES + headerBytes.length);
  return message.buffer;
};

export const parseFileChunkMessage = (messageBuffer) => {
  const bytes = new Uint8Array(messageBuffer);
  const headerLength = new DataView(bytes.buffer).getUint32(0);
  const headerEnd = HEADER_BYTES + headerLength;

  return {
    metadata: decodeJson(bytes.slice(HEADER_BYTES, headerEnd)),
    bytes: bytes.slice(headerEnd),
  };
};

export const buildReceivedFile = ({ fileMetadata, chunks }) => {
  if (!fileMetadata) return null;

  return new File(chunks, fileMetadata.name, {
    type: fileMetadata.type,
    lastModified: fileMetadata.lastModified,
  });
};

export const buildCompleteTransferMessage = () =>
  buildTextMessage({ type: TRANSFER_MESSAGE_TYPES.TRANSFER_COMPLETE });

export const buildReceiverReadyMessage = () =>
  buildTextMessage({ type: TRANSFER_MESSAGE_TYPES.RECEIVER_READY });
